import { handleActions } from 'redux-actions';
import { State, stateUpdate, stateClear, stateReload, StateUpdatePayload, StateClearPayload, StateReloadPayload } from './action';

const initialState: State = {
  policy_customer: {
    isLoading: false,
    isReload: false,
  },
  policy_insurer: {
    isLoading: false,
    isReload: false,
  }
};

export default handleActions(
  {
    [String(stateUpdate)]: (state, { payload }) => {
      const { documentType, ...rest } = payload as unknown as StateUpdatePayload;
      return {
        ...state,
        [documentType]: {
          ...state[documentType],
          ...rest,
        },
      };
    },
    [String(stateClear)]: (state, { payload }) => {
      const { documentType } = payload as unknown as StateClearPayload;
      return {
        ...state,
        [documentType]: initialState[documentType],
      }
    },
    [String(stateReload)]: (state, { payload }) => {
      const { documentType } = payload as unknown as StateReloadPayload;
      return {
        ...state,
        [documentType]: {
          ...state[documentType],
          isReload: !state[documentType].isReload,
        },
      };
    },

  },
  initialState,
);
